export const baseUrl = process.env.REACT_APP_REST_API_URL;
